// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"439":"Offer","848":"Register"}[chunkId] + "." + {"439":"5551e6ec","848":"edc7e0ff"}[chunkId] + ".chunk.css";
};